import modelBaseV2 from "../model-base-v2.model";

/**
 * Fixture Master Model
 * 
 * This feature is for admin register fixtures.
 * 
 * @author Molly Liu
 */

const storeFixtureMappingModel = {
  getStoreBaseMappingList: (body) => {
    return modelBaseV2.post('/api/planogram/storefixturemap/lists', { body });
  },
  uploadMapping: (file, fileName) => {
		const body = new FormData();
		body.append('file', file);
		return modelBaseV2.postDownload('/api/planogram/storefixturemap/upload', { body }, fileName);
	},
	downloadStoreBaseMapping: (body, fileName) => {
		return modelBaseV2.postDownload('/api/planogram/storefixturemap/lists/download', {body}, fileName);
	},
  downloadStoreBasePPT: (body, fileName) => {
		return modelBaseV2.postDownload('/api/planogram/storefixturemap/downloadpptx', {body}, fileName);
	}
}

export default storeFixtureMappingModel;
